declare const Pusher: any;
import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment } from "../../environments/environment";

@Injectable()
export class PuserserviceService {

    // pusher: any;
    // channel: any;
    // channelprice: any;

    // constructor(private http: HttpClient) {
    //     this.pusher = new Pusher(environment.pusher.key, {
    //         cluster: environment.pusher.cluster,
    //         encrypted: true
    //     });
    //     this.channel = this.pusher.subscribe(environment.pusher.channel);
    //     this.channelprice = this.pusher.subscribe(environment.pusher.channelprice);
    // }

}



// WEBPACK FOOTER //
// ./src/app/services/puserservice.service.ts